import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../mockData';

const Services = () => {
    return (
        <section className="py-16 md:py-24 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        HİZMETLERİMİZ
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Profesyonel ekibimiz ve modern ekipmanlarımızla, aracınızın far ve stoplarına özel çözümler sunuyoruz.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.map((service) => (
                        <Link
                            key={service.id}
                            to={service.link}
                            className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                        >
                            <div className="relative h-64 overflow-hidden">
                                <img
                                    src={`${service.image}?w=600&h=400&fit=crop`}
                                    alt={service.title}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent"></div>
                                <div className="absolute bottom-4 left-4 right-4">
                                    <h3 className="text-xl font-bold text-white mb-1">{service.title}</h3>
                                </div>
                            </div>
                            <div className="p-6">
                                <p className="text-gray-600 mb-4">{service.description}</p>
                                <div className="flex items-center text-blue-600 font-semibold group-hover:gap-2 transition-all">
                                    <span>Detaylı Bilgi</span>
                                    <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <Link
                        to="/hizmetler"
                        className="inline-flex items-center space-x-2 bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all hover:scale-105 shadow-lg text-lg font-semibold"
                    >
                        <span>TÜM HİZMETLER</span>
                        <ArrowRight size={24} />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Services;
